import { render } from "./MagicLinkLogin.vue?vue&type=template&id=54079889"
import script from "./MagicLinkLogin.vue?vue&type=script&lang=js"
export * from "./MagicLinkLogin.vue?vue&type=script&lang=js"

import "./MagicLinkLogin.vue?vue&type=style&index=0&id=54079889&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__